module.exports = __webpack_public_path__ + "static/img/newanli-20.1457834b.jpg";